import React from "react";
import {
  createStyles,
  Header,
  Group,
  ActionIcon,
  Container,
  Burger,
  Stack,
} from "@mantine/core";
import { useBooleanToggle } from "@mantine/hooks";
const { BrandGithub, BrandLinkedin } = require("tabler-icons-react");

const useStyles = createStyles((theme) => ({
  name: {
    fontFamily: "Raleway, sans-serif",
    fontSize: "30px",
  },

  inner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 56,

    [theme.fn.smallerThan("sm")]: {
      justifyContent: "flex-start",
    },
  },

  links: {
    width: 260,

    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },

  social: {
    width: 260,

    [theme.fn.smallerThan("sm")]: {
      width: "auto",
      marginLeft: "auto",
    },
  },

  burger: {
    marginRight: theme.spacing.md,

    [theme.fn.largerThan("sm")]: {
      display: "none",
    },
  },

  link: {
    display: "block",
    lineHeight: 1,
    padding: "8px 12px",
    textDecoration: "none",
    borderRadius: theme.radius.sm,
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[0]
        : theme.colors.gray[7],
    fontSize: theme.fontSizes.xs,
    fontWeight: 500,

    "&:hover": {
      backgroundColor: "#FAEBD7",
      fontWeight: "bolder",
      color: "black",
    },
  },
  header: {
    borderBottom: "none",
    backgroundColor: "#FFFAF1",

    [theme.fn.largerThan("lg")]: {
      padding: "0 30px",
    },
  },
  stack: {
    position: "absolute",
    top: "60px",
    backgroundColor: "white",
    padding: "10px",

    [theme.fn.largerThan("sm")]: {
      display: "none",
    },
  },
  icon: {
    "&:hover": {
      backgroundColor: "#FAEBD7",
    },
  },
}));

interface HeaderMiddleProps {
  links: { link: string; label: string }[];
}

const HeaderBar = ({ links }: HeaderMiddleProps) => {
  const [opened, toggleOpened] = useBooleanToggle(false);
  const { classes } = useStyles();

  const openSocial = (social: string) => {
    const url =
      social === "git"
        ? "https://github.com/benjaminho1998"
        : "https://www.linkedin.com/in/benjadho/";
    window.open(url, "_blank");
  };

  const items = links.map((link) => (
    <a
      key={link.label}
      href="/"
      className={classes.link}
      onClick={(e) => {
        e.preventDefault();
        const element = document.getElementById(link.link);
        element &&
          element.scrollIntoView({ behavior: "smooth", block: "start" });
      }}
    >
      {link.label}
    </a>
  ));

  return (
    <Header id="about" className={classes.header} height={56} mb={120}>
      <Container fluid className={classes.inner}>
        <Burger
          opened={opened}
          onClick={() => toggleOpened()}
          size="sm"
          className={classes.burger}
        />
        {opened && <Stack className={classes.stack}>{items}</Stack>}
        <Group className={classes.links} spacing={5}>
          {items}
        </Group>

        <div className={classes.name}>BH</div>

        <Group spacing={0} className={classes.social} position="right" noWrap>
          <ActionIcon
            className={classes.icon}
            size="lg"
            onClick={() => openSocial("git")}
          >
            <BrandGithub size={18} />
          </ActionIcon>
          <ActionIcon
            className={classes.icon}
            size="lg"
            onClick={() => openSocial("link")}
          >
            <BrandLinkedin size={18} />
          </ActionIcon>
        </Group>
      </Container>
    </Header>
  );
};

export default HeaderBar;
